import api from './api';

export interface Permission {
  id: number;
  name: string;
  guard_name: string;
  created_at: string;
  updated_at: string;
}

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export const permissionService = {
  async getAll(): Promise<Permission[]> {
    const response = await api.get('/permissions');
    return unwrap<Permission[]>(response);
  },
};
